import { rem } from 'polished';
import styled from 'styled-components';

export const Fieldset = styled.fieldset`
  .notes {
    margin-bottom: ${rem(24)};
    font-size: ${rem(14)};
    line-height: 140%;
  }

  .full-width {
    margin: 0;

    &,
    button {
      width: 100%;
    }
  }
`;
